import { Button } from "antd";
import { Link } from "react-router-dom";

interface NavigateButtonProps {
  /**
   * The path to navigate to when the button is clicked
   */
  targetPath: string;
  name: string;
  id?: string | undefined;
  /**
   * Optional additional function to call when the button is clicked
   */
  onClick?: () => void;
  /**
   * Optional disable button
   */
  size?: "small" | "middle" | "large";
}

const NavigateButton = ({
  targetPath,
  name,
  id,
  onClick,
  size,
}: NavigateButtonProps) => {
  const routePath = id ? `${targetPath}/${id}` : targetPath;

  return (
    <Link to={{ pathname: routePath }}>
      <Button type="primary" onClick={onClick} size={size}>
        {name}
      </Button>
    </Link>
  );
};

export default NavigateButton;
